const tr = {
  meta: {
    siteName: "Nieder-Eschbacher Pflegedienst GmbH",
    titleSuffix: "Nieder-Eschbacher Pflegedienst",
    description:
      "Nieder-Eschbacher Pflegedienst GmbH, Frankfurt am Main'de evde bakım hizmeti. Şefkatli ve uzman evde bakım: temel bakım, tıbbi bakım, ev işleri ve 24 saat ulaşılabilirlik.",
    pages: {
      home: "",
      about: "Hakkımızda",
      services: "Hizmetler",
      news: "Haberler ve İş İlanları",
      contact: "İletişim",
      imprint: "Künye",
      privacy: "Gizlilik Politikası",
      notFound: "Sayfa bulunamadı",
    },
  },

  common: {
    call: "Ara",
    callNow: "Hemen arayın:",
    contactUs: "Bize ulaşın",
    bookConsultation: "Danışma randevusu alın",
    bookAppointment: "Randevu alın",
    requestConsultation: "Danışma talep edin",
    aroundTheClock: "Günün her saati:",
    reachable24h: "Günün her saati ulaşılabilir",
    certifiedStaff: "Diplomalı hemşireler",
    whatsapp: "WhatsApp",
    whatsappText: "Merhaba, bakım hizmetinizle ilgili bir sorum var.",
    whatsappNote: "Lütfen WhatsApp üzerinden sağlık verisi göndermeyin. Acil durumlarda lütfen bizi arayın.",
    symbolImage: "Temsili görsel",
    language: "Dil",
    changeLanguage: "Dil seçin",
    skipToContent: "İçeriğe geç",
    legalNote: "Bu çeviri yalnızca bilgilendirme amaçlıdır. Hukuken bağlayıcı olan Almanca metindir.",
  },

  header: {
    topbar24h: "24 saat ulaşılabilir",
    topbarConsult: "Ücretsiz ve kişisel danışmanlık",
    mainNav: "Ana menü",
    mobileNav: "Mobil menü",
    openMenu: "Menüyü aç",
    closeMenu: "Menüyü kapat",
  },

  nav: {
    home: "Ana Sayfa",
    about: "Hakkımızda",
    services: "Hizmetler",
    news: "Haberler",
    contact: "İletişim",
    jobs: "İş İlanları",
    imprint: "Künye",
    privacy: "Gizlilik",
  },

  footer: {
    reach: "Bize ulaşın",
    fax: "Faks:",
    emergency: "24 saat acil hat:",
    navigation: "Menü",
    legal: "Yasal bilgiler",
    area: "Frankfurt am Main ve çevresi (ağırlıklı olarak Nieder-Eschbach)",
    rights: "Tüm hakları saklıdır.",
  },

  floating: {
    whatsappLabel: "Bize WhatsApp'tan yazın",
    callLabel: "Hemen arayın:",
    toTop: "Yukarı çık",
  },

  home: {
    eyebrow: "Evde bakım hizmeti · Frankfurt am Main",
    h1a: "Şefkatli ve uzman",
    h1b: "evde bakım",
    lead:
      "Yaşlılık ya da hastalık nedeniyle bakıma ihtiyaç duysanız bile kaygısız bir yaşam için. Size zaman ayırıyoruz.",
    heroImgAlt: "Nieder-Eschbacher Pflegedienst bakıcısı gülümseyen yaşlı bir beyefendinin omuzlarına ellerini koyuyor; yanında logo ve hizmetler: temel bakım, tıbbi bakım, ev işlerinde destek, bireysel refakat",
    badgeTitle: "Yürekten ve zaman ayırarak",
    badgeText: "Acele etmeyen bakım",
    welcomeQuote:
      "Biz, Frankfurt am Main'deki Nieder-Eschbacher Pflegedienst ekibi, ilginizden dolayı memnunuz. Bize güvenen insanlar için her gün var gücümüzle çalışıyor, kendi evinizin mahremiyetinde kaliteli bir bakım sunuyoruz. Güler yüzlü hemşirelerimiz size zaman ayırır.",
    features: [
      {
        icon: "Clock",
        title: "Size zaman ayırıyoruz",
        text: "Telaşsız, özenli bir yaklaşım. Yanımızda kendinizi iyi hissetmenizi istiyoruz.",
        to: "about",
        cta: "Hakkımızda",
      },
      {
        icon: "HeartHandshake",
        title: "Hizmetlerimiz",
        text: "Size özel planlanan temel ve tıbbi bakım.",
        to: "services",
        cta: "Hizmetler",
      },
      {
        icon: "Newspaper",
        title: "Haberler ve iş ilanları",
        text: "Bakım hizmetimizden haberler ve açık pozisyonlar.",
        to: "news",
        cta: "Haberler",
      },
    ],
    servicesEyebrow: "Hizmetlerimiz",
    servicesTitle: "İhtiyaçlarınıza göre bireysel bakım",
    servicesLead:
      "Temel bakımdan 24 saat ulaşılabilirliğe kadar: alıştığınız evinizde size kapsamlı biçimde eşlik ediyoruz.",
    valuesEyebrow: "Değerlerimiz",
    valuesTitle: "Saygı, özen ve sorumlu bir yaklaşım",
    valuesLead:
      "Saygı, özen ve sorumlu bir yaklaşım en temel ilkelerimizdir. Her insana, kendimize davranılmasını istediğimiz gibi davranırız.",
    ctaTitle: "Hangi bakım derecesine sahip olduğunuzdan emin değil misiniz?",
    ctaLead: "Ofisimizde ya da evinizde size memnuniyetle bizzat danışmanlık veririz. Ücretsiz ve bağlayıcılık olmadan.",
  },

  values: [
    { icon: "Heart", label: "Bireysel bakım" },
    { icon: "BadgeCheck", label: "Diplomalı hemşireler" },
    { icon: "MessageCircle", label: "Kişisel danışmanlık" },
    { icon: "ShieldCheck", label: "Sorumlu yaklaşım" },
  ],

  services: [
    {
      id: "grundpflege",
      icon: "HandHeart",
      title: "Temel bakım",
      short: "Vücut bakımı, hareket desteği ve günlük yaşamda yardım; sakin ve onurlu biçimde.",
      description:
        "Temel bakımda vücut temizliği ve hareketle ilgili tüm günlük işlerde size şefkatle destek oluyoruz. Zaman ayırıyor, onurunuza ve kendi kararlarınıza her zaman saygı gösteriyoruz.",
      points: [
        "Vücut bakımı (yıkanma, banyo, duş)",
        "Hareket desteği ve pozisyon verme",
        "İnkontinans bakımı",
        "Yemek yemede destek",
        "Giyinme ve soyunma",
      ],
    },
    {
      id: "behandlungspflege",
      icon: "Stethoscope",
      title: "Tıbbi bakım",
      short: "Doktor talimatıyla tıbbi bakım; güvenilir ve uzmanca.",
      description:
        "Tıbbi bakım, tıbben gerekli tüm uygulamaları kapsar ve her zaman doktor talimatıyla yapılır. Diplomalı hemşirelerimiz doktorlarınızla yakın iş birliği içinde çalışır.",
      points: [
        "İlaç verme ve hazırlama",
        "Enjeksiyonlar",
        "Varis çorabı giydirme ve çıkarma",
        "Modern yara bakımı",
        "Kan şekeri ve tansiyon kontrolü",
      ],
      note: "Tıbbi bakım her zaman doktor talimatıyla uygulanır.",
    },
    {
      id: "hauswirtschaft",
      icon: "Home",
      title: "Ev işleri",
      short: "Evinizde kendinizi her yönüyle rahat hissetmeniz için ev işlerini üstleniyoruz.",
      description:
        "Bakımlı bir ev, iyi hissetmenin önemli bir parçasıdır. Kendi evinizde huzurlu ve güvende hissetmeniz için ev işlerinde size destek oluyoruz.",
      points: [
        "Alışveriş ve günlük işler",
        "Yemek hazırlama",
        "Çamaşır",
        "Ev temizliği",
      ],
    },
    {
      id: "betreuung",
      icon: "Users",
      title: "Ek refakat hizmetleri",
      short: "Birlikte geçirilen zaman, sohbet ve etkinliklerle daha fazla yaşam sevinci.",
      description:
        "Bakımın yanı sıra insani yakınlık bizim için çok önemlidir. Bakım veren yakınlarınızın yükünü hafifletiyor, güzel ortak anlar için size zaman kazandırıyoruz.",
      points: [
        "Bakım veren yakınlara destek",
        "Yönelim egzersizleri",
        "Sohbet ve eşlik",
        "Yaşam öyküsü çalışması",
      ],
    },
    {
      id: "anleitung",
      icon: "GraduationCap",
      title: "Bakım veren yakınlara rehberlik",
      short: "Yakınlarınızın size destek olabilmesi için onlara destek oluyoruz.",
      description:
        "Bakım veren yakınlar büyük bir iş yapıyor. Bakım konusunda pratik rehberlik ve güven veriyoruz; kendi evinizde, size özel ve anlaşılır biçimde.",
      points: [
        "Evde uygulamalı bakım eğitimi",
        "Yardımcı araçlar hakkında danışmanlık",
        "Bakım gerektiren günlük yaşam için ipuçları",
        "Bakımda güven kazanma",
      ],
    },
    {
      id: "erreichbarkeit",
      icon: "Clock",
      title: "24 saat ulaşılabilirlik",
      short: "Kendinizi güvende hissetmeniz için mobil hattımızdan günün her saati ulaşılabiliriz.",
      description:
        "Acil durumlarda gece gündüz demeden yanınızdayız. Mobil acil numaramızdan bize günün her saati ulaşabilirsiniz.",
      points: [
        "Mobil acil hat: 0177 / 7202956",
        "Alternatif: 0157 / 36442746",
        "Acil durumda hızlı yardım",
        "Sizin ve yakınlarınız için güvence",
      ],
    },
  ],

  servicesPage: {
    eyebrow: "Hizmetler",
    title: "Kapsamlı bakım, size özel",
    subtitle:
      "Durumunuza tam olarak uyarladığımız geniş bir bakım ve ev işleri hizmet yelpazesi sunuyoruz.",
    shortLongTitle: "Kısa süreli ve sürekli bakım",
    shortLongText:
      "İster hastane çıkışı sonrası geçici olarak, ister sürekli: bakımımızı yaşam koşullarınıza esnek biçimde uyarlıyoruz. Böylece tam da şu anda ihtiyaç duyduğunuz desteği alırsınız.",
    adviceTitle: "Bakım derecesi ve bakım sigortası danışmanlığı",
    adviceText:
      "Bakım sistemi karmaşıktır. Hangi hizmetlere hakkınız olduğunu anlaşılır biçimde açıklıyor ve bakım sigortasına başvurunuzda adım adım destek oluyoruz.",
    ctaTitle: "Ücretsiz danışmanlık talep edin",
    ctaLead: "Ofisimizde ya da evinizde, bağlayıcılık olmadan size bizzat danışmanlık veririz.",
  },

  about: {
    eyebrow: "Hakkımızda",
    title: "Zaman ayıran insanlar",
    subtitle:
      "Ekibimizi ve anlayışımızı tanıyın. Bizi zaman, saygı, özen ve gerçek insanlık tanımlar.",
    introTitle: "Öncelik sizin iyiliğiniz",
    intro: [
      "Biz Frankfurt am Main'deki Nieder-Eschbacher Pflegedienst ekibiyiz. Bize güvenen insanlar için her gün var gücümüzle çalışıyoruz. Bizim için bakım bir işten çok daha fazlası, gönül işidir.",
      "Güler yüzlü, diplomalı hemşirelerimiz size bilinçli olarak zaman ayırır. Çünkü iyi bir bakım sükûnet, ilgi ve dinlemeye hazır bir kulak ister; telaş değil.",
      "Sizi kendinizi en iyi hissettiğiniz yerde, alıştığınız ortamda, kendi evinizde bakıyoruz. Böylece bağımsızlığınız ve mahremiyetiniz korunur.",
    ],
    teamImgAlt: "Bir bakıcı, tekerlekli sandalyedeki yaşlı bir hanımın ellerini şefkatle tutuyor (temsili görsel)",
    valuesTitle: "Bize yön veren değerler",
    valuesLead: "Saygı, özen ve sorumlu bir yaklaşım en temel ilkelerimizdir.",
    pillars: [
      { icon: "Clock", title: "Zaman", text: "Telaşsız çalışır, size gerçek ilgi gösteririz." },
      { icon: "Heart", title: "Özen", text: "Her insan biriciktir. Bakımımız da öyle." },
      { icon: "Home", title: "Ev", text: "Güven veren, alışık olduğunuz ortamda bakım." },
    ],
    ctaTitle: "Bizi tanıyın",
    ctaLead: "Sizinle yüz yüze görüşmeyi dört gözle bekliyoruz.",
  },

  newsPage: {
    eyebrow: "Haberler",
    title: "Haberler ve iş ilanları",
    subtitle: "Bakım hizmetimizden haberler ve ekibimize katılmak isteyen herkes için açık pozisyonlar.",
    newsTitle: "Haberler",
    newsLead: "Bakım hizmetimizden güncel bilgiler.",
    careerEyebrow: "Kariyer",
    careerTitle: "Ekibimizin bir parçası olun",
    careerLead:
      "Bakım işini seviyor ve insanlara gerçekten zaman ayıran sıcak bir ekipte çalışmak mı istiyorsunuz? O halde başvurunuzu bekliyoruz.",
    applyNow: "Hemen başvurun",
    applySubject: "Başvuru: Bakım yardımcısı (k/e/d)",
    tasks: "Görevleriniz",
    profile: "Profiliniz",
    offer: "Sunduklarımız",
    interested: "İlginizi çekti mi? Başvurunuzu şu adrese gönderin:",
    orCall: "ya da bizi arayın:",
    questions: "Sorunuz mu var? Bize ulaşın",
  },

  news: [
    {
      id: "willkommen",
      date: "2026-09-21",
      category: "Haberler",
      title: "Yeni web sitemize hoş geldiniz",
      excerpt:
        "Bakım hizmetimizi ve sunduklarımızı artık internet üzerinden de tanıtabildiğimiz için mutluyuz: düzenli, anlaşılır ve her zaman erişilebilir.",
      body: "Amacımız, evde bakımla ilgili tüm önemli bilgileri size ve yakınlarınıza kolayca ulaştırmak. Sorularınız için bize her zaman telefonla ya da iletişim formumuz üzerinden ulaşabilirsiniz.",
    },
    {
      id: "pflegeberatung",
      date: "2025-10-28",
      category: "Danışmanlık",
      title: "Ofisimizde ya da evinizde ücretsiz bakım danışmanlığı",
      excerpt:
        "Hangi bakım derecesinin size uygun olduğundan emin değil misiniz? Bakım sigortası ve bakım dereceleriyle ilgili tüm sorularınızda size bizzat ve bağlayıcılık olmadan danışmanlık veriyoruz.",
      body: "Almanya'daki bakım sistemi karmaşıktır. Zaman ayırıyor, seçenekleri sakin bir ortamda açıklıyor ve hizmet başvurularınızda size destek oluyoruz. Bir randevu almanız yeterli.",
    },
    {
      id: "team-verstaerkung",
      date: "2025-10-05",
      category: "Ekip",
      title: "Büyüyoruz ve yeni çalışma arkadaşları arıyoruz",
      excerpt:
        "Ekibimiz sürekli büyüyor. Bakımı zaman ayırarak ve saygıyla yaşayan sıcak bir ekibin parçası olun.",
      body: "Adil çalışma koşulları, değer veren bir ortam ve baktığımız insanlar için gerçek zaman sunuyoruz. Güncel iş ilanlarımıza göz atın.",
    },
  ],

  jobs: [
    {
      id: "pflegehelfer",
      title: "Bakım yardımcısı (k/e/d)",
      type: "Yarı zamanlı veya tam zamanlı",
      location: "Frankfurt am Main, Nieder-Eschbach",
      intro:
        "Ekibimizi güçlendirmek için zaman, saygı ve özen değerlerimizi yaşatacak bir bakım yardımcısı arıyoruz. Bu işe gönül vermiş meslek değiştirenler de memnuniyetle karşılanır.",
      tasks: [
        "Danışanlarımızın temel bakımında destek",
        "Hareket ve günlük yaşamda yardım",
        "Eşlik etme ve insani yakınlık",
        "Bakım ekibiyle yakın iş birliği",
      ],
      requirements: [
        "İnsanlarla çalışmaktan keyif almak ve empati",
        "Güvenilirlik, sorumluluk bilinci ve ekip ruhu",
        "Bakımda ilk deneyim avantajdır (zorunlu değil)",
        "B sınıfı ehliyet avantajdır",
      ],
      offer: [
        "Adil ve zamanında ödenen ücret",
        "Değer veren, sıcak bir ekip",
        "Bakım için gerçek zaman, telaş yok",
        "İşe alıştırma ve mesleki eğitimler",
      ],
    },
  ],

  contact: {
    eyebrow: "İletişim",
    title: "Sizin için buradayız",
    subtitle:
      "Bakımla ilgili sorular, randevu talebi ya da danışmanlık: bağlayıcılık olmadan bizimle iletişime geçin. Sizi bekliyoruz.",
    formTitle: "Bize yazın",
    formLead: "En kısa sürede size dönüş yapacağız.",
    name: "Ad Soyad",
    namePlaceholder: "Adınız",
    email: "E-posta",
    emailPlaceholder: "isim@ornek.de",
    phone: "Telefon",
    phonePlaceholder: "Telefon numaranız",
    message: "Mesaj",
    messagePlaceholder: "Size nasıl yardımcı olabiliriz?",
    consentBefore: "",
    consentLink: "Gizlilik politikasını",
    consentAfter:
      "okudum; verilerimin (mesajımdaki sağlıkla ilgili bilgiler dahil) talebimin işlenmesi amacıyla kullanılmasına onay veriyorum. Bu onayı istediğim zaman geri alabilirim.",
    submit: "Mesajı gönder",
    sending: "Gönderiliyor…",
    subject: "Web sitesi üzerinden iletişim talebi",
    errName: "Lütfen adınızı girin.",
    errEmail: "Lütfen geçerli bir e-posta adresi girin.",
    errMessage: "Lütfen bize kısa bir mesaj yazın.",
    errConsent: "Lütfen gizlilik politikasını onaylayın.",
    toastCheck: "Lütfen girdiklerinizi kontrol edin.",
    toastSuccess: "Teşekkürler! Mesajınız başarıyla gönderildi.",
    toastError: "Bir hata oluştu. Lütfen bizi arayın.",
    successTitle: "Teşekkürler!",
    successText: "Mesajınız iletildi. Kısa süre içinde size dönüş yapacağız.",
    sendAnother: "Yeni mesaj gönder",
    reachTitle: "Bize nasıl ulaşırsınız",
    address: "Adres",
    phoneLabel: "Telefon",
    fax: "Faks",
    emergency: "24 saat acil hat",
    alternatively: "alternatif",
    emailLabel: "E-posta",
    hoursTitle: "Çalışma saatleri",
    hours: "Pazartesi ile Cuma arası: 08:00 ile 17:00 arası",
    careAndEmergency: "Bakım hizmeti ve acil hat:",
    aroundTheClock: "günün her saati",
    mapTitle: "Bizi nasıl bulursunuz",
    mapIframeTitle: "Nieder-Eschbacher Pflegedienst'in Google Haritalar'daki konumu",
    mapLoad: "Haritayı yükle",
    mapNotice:
      "Gizlilik nedeniyle Google Haritalar yalnızca onayınızdan sonra yüklenir. Bu sırada Google'a veri aktarılır.",
    mapButton: "Haritayı yükle ve konumu göster",
    mapAlt: "Ya da Google Haritalar'da açın",
  },

  reviews: {
    eyebrow: "Değerlendirmeler",
    title: "Yakınlar ve hastalar ne diyor",
    emptyLead: "Deneyiminiz, Frankfurt'taki diğer ailelerin doğru bakım hizmetini bulmasına yardımcı olur.",
    countOn: "değerlendirme,",
    source: "Google İşletme Profilimizdeki herkese açık değerlendirmeler.",
    asOf: "Güncelleme:",
    all: "Google'daki tüm değerlendirmeler",
    write: "Değerlendirme yazın",
    on: "kaynak:",
    starsLabel: "/ 5 yıldız",
  },

  notFound: {
    title: "Sayfa bulunamadı",
    subtitle: "Hata 404",
    text: "Aradığınız sayfa mevcut değil ya da taşınmış.",
    home: "Ana sayfaya dön",
  },

  imprint: {
    title: "Künye",
    subtitle: "Alman Dijital Hizmetler Kanunu (DDG) § 5 uyarınca bilgiler",
    company: "DDG § 5 uyarınca bilgiler",
    country: "Almanya",
    representedBy: "Temsilci",
    managingDirector: "Genel müdür",
    contact: "İletişim",
    phone: "Telefon",
    fax: "Faks",
    email: "E-posta",
    register: "Ticaret sicili kaydı",
    registerCourt: "Sicil mahkemesi",
    registerNumber: "Sicil numarası",
    taxNumber: "Vergi numarası",
    licence: "Ruhsat ve denetim makamı",
    licenceText:
      "Hessen'deki bakım sigortası eyalet birlikleriyle yapılan, Sosyal Kanun XI. Kitap (SGB XI) § 72 uyarınca bakım sözleşmesi ile ruhsatlı evde bakım hizmeti.",
    authorityText:
      "Hessen Refakat ve Bakım Hizmetleri Kanunu (HGBP) uyarınca yetkili denetim makamı:",
    dispute: "Tüketici uyuşmazlıklarının çözümü",
    disputeText:
      "Bir tüketici hakem heyeti önünde uyuşmazlık çözüm sürecine katılmaya istekli ve yükümlü değiliz (VSBG § 36).",
    responsible: "Eyalet Medya Sözleşmesi (MStV) § 18 f. 2 uyarınca içerikten sorumlu",
    credit: "Konsept ve teknik uygulama",
    liabilityContent: "İçerik sorumluluğu",
    liabilityContentText:
      "Hizmet sağlayıcı olarak bu sayfalardaki kendi içeriklerimizden genel yasalar uyarınca sorumluyuz. Ancak iletilen ya da depolanan üçüncü taraf bilgilerini izlemek veya hukuka aykırı bir faaliyete işaret eden durumları araştırmakla yükümlü değiliz (2022/2065 sayılı (AB) Tüzüğü, Dijital Hizmetler Yasası, madde 8). Bilgilerin kullanımının genel yasalara göre kaldırılması veya engellenmesi yükümlülükleri saklıdır. Bu konudaki sorumluluk ancak somut bir hukuk ihlalinden haberdar olunduğu andan itibaren mümkündür. Böyle bir ihlalden haberdar olur olmaz ilgili içerikleri derhal kaldırırız.",
    liabilityLinks: "Bağlantı sorumluluğu",
    liabilityLinksText:
      "Sitemiz, içeriklerine etki edemediğimiz üçüncü tarafların harici web sitelerine bağlantılar içerir. Bu nedenle bu yabancı içerikler için herhangi bir garanti veremeyiz. Bağlantı verilen sayfaların içeriğinden her zaman ilgili sağlayıcı ya da işletmeci sorumludur. Bağlantı verilen sayfalar, bağlantı verildiği tarihte olası hukuk ihlalleri açısından kontrol edilmiştir; o tarihte hukuka aykırı içerik tespit edilmemiştir. Somut bir ihlal belirtisi olmadan bağlantı verilen sayfaların sürekli olarak denetlenmesi makul değildir. Hukuk ihlallerinden haberdar olur olmaz bu tür bağlantıları derhal kaldırırız.",
    copyright: "Telif hakkı",
    copyrightText:
      "Site işletmecisi tarafından oluşturulan bu sayfalardaki içerik ve eserler Alman telif hakkı hukukuna tabidir. Telif hakkı sınırları dışında çoğaltma, işleme, dağıtma ve her türlü kullanım, ilgili yazarın ya da yaratıcının yazılı iznini gerektirir. Bu sitenin indirilmesi ve kopyalanması yalnızca özel, ticari olmayan kullanım için serbesttir. Bu sitedeki içerikler işletmeci tarafından oluşturulmadığı ölçüde üçüncü tarafların telif haklarına saygı gösterilir; özellikle üçüncü taraf içerikleri bu şekilde işaretlenir. Buna rağmen bir telif hakkı ihlali fark ederseniz lütfen bize bildirin. İhlallerden haberdar olur olmaz bu tür içerikleri derhal kaldırırız.",
  },

  privacy: {
    title: "Gizlilik Politikası",
    subtitle: "GDPR (DSGVO) uyarınca kişisel verilerinizin işlenmesine ilişkin bilgiler",
    retention: "altı ay",
    lastUpdated: "Güncelleme: Ekim 2026",
    controller: {
      title: "1. Veri sorumlusu",
      lead: "Genel Veri Koruma Tüzüğü (GDPR) anlamında bu web sitesindeki veri işlemeden sorumlu olan:",
      representedBy: "temsilen genel müdür",
      phone: "Telefon",
      fax: "Faks",
      email: "E-posta",
    },
    dpo: {
      title: "Veri koruma görevlisi",
      lead: "Veri koruma görevlimize şu adresten ulaşabilirsiniz:",
    },
    general: {
      title: "2. Veri işlemeye ilişkin genel bilgiler",
      p: [
        "Kişisel verileri yalnızca işlevsel bir web sitesi sunmak ve taleplerinizi işlemek için gerekli olduğu ölçüde işleriz. Hukuki dayanaklar: GDPR md. 6 f. 1 (a) (rıza), md. 6 f. 1 (b) (sözleşme ya da sözleşme öncesi adımlar) ve md. 6 f. 1 (f) (bu web sitesinin güvenli ve istikrarlı işletilmesindeki meşru menfaat).",
        "Bu web sitesi **çerez kullanmaz**, cihazınıza bilgi kaydetmez (TDDDG § 25) ve analiz, izleme ya da reklam hizmeti kullanmaz. Yazı tipleri ve görseller kendi sunucumuzdan sunulur; sayfaları açtığınızda üçüncü taraf yazı tipi veya görsel hizmetlerine veri gönderilmez. Profilleme dahil, yalnızca otomatik karar verme (GDPR md. 22) yapılmaz.",
      ],
    },
    hosting: {
      title: "3. Barındırma ve sunucu günlük dosyaları",
      ownIntro:
        "Bu web sitesi bizim adımıza {operator} tarafından Almanya'daki bir sunucuda işletilmektedir. Veri merkezi ve sunucu sağlayıcısı {provider}.",
      logs: "Her erişimde teknik olarak gerekli bağlantı verileri işlenir: IP adresi, erişim tarihi ve saati, açılan sayfa, aktarılan veri miktarı, tarayıcı türü ve sürümü, işletim sistemi ve önceki sayfa (yönlendiren). Bu veriler başka veri kaynaklarıyla birleştirilmez; yalnızca web sitesinin sunulması, güvenliği ve hata analizi için kullanılır. Hukuki dayanak GDPR md. 6 f. 1 (f)'dir. Sunucu günlük dosyaları yalnızca güvenli işletim için gerekli olduğu sürece saklanır, ardından silinir veya anonimleştirilir.",
      ownLegal:
        "İşletmeci ve veri merkezi sağlayıcısı ile GDPR md. 28 uyarınca veri işleme sözleşmeleri mevcuttur. Barındırma kapsamında üçüncü ülkelere veri aktarımı yapılmaz.",
    },
    form: {
      title: "4. İletişim formu",
      p: [
        "İletişim formu üzerinden bize bir talep gönderdiğinizde, girdiğiniz verileri (ad, e-posta adresi, isteğe bağlı telefon numarası ve mesajınız) talebinizi ve olası ek soruları yanıtlamak için işleriz. Hukuki dayanak GDPR md. 6 f. 1 (b) (bir bakım ilişkisinin kurulmasına yönelik adımlar) ve, sağlıkla ilgili bilgiler paylaşmanız halinde, formdaki onay kutusu aracılığıyla verdiğiniz GDPR md. 9 f. 2 (a) uyarınca açık rızanızdır.",
        "Ad, e-posta adresi ve mesaj zorunludur; telefon numarası isteğe bağlıdır. Zorunlu bilgiler olmadan talebinizi işleyemeyiz; bu durumda bize her zaman telefonla ulaşabilirsiniz. Aktarım şifreli (TLS) yapılır. Talebiniz yalnızca Almanya'da görevlendirdiğimiz bir sunucuda saklanır ve üçüncü taraflara verilmez. Bir bakım ilişkisi kurulmaz ve yasal saklama yükümlülükleri engel oluşturmazsa, verileri talebinizin sonuçlanmasından en geç {retention} sonra sileriz. Rızanızı ileriye dönük olarak istediğiniz zaman geri alabilirsiniz, örneğin {email} adresine e-posta göndererek.",
      ],
    },
    emailPhone: {
      title: "5. E-posta, telefon veya WhatsApp ile iletişim",
      p: [
        "Bize e-posta ya da telefonla ulaştığınızda, bilgilerinizi talebinizi işlemek için kullanırız (GDPR md. 6 f. 1 (b) ve (f)). Şifrelenmemiş e-postaların iletim sırasında üçüncü taraflarca okunabileceğini lütfen unutmayın; sağlıkla ilgili bilgiler için telefonu ya da yüz yüze görüşmeyi öneririz.",
        "{email} adresine gönderilen e-postalar bize bir yönlendirme hizmeti üzerinden ulaşır: iletim hizmeti {forwarder}, posta kutusu ise {mailbox} nezdindedir. Bu sırada gönderen adresiniz, konu başlığınız ve mesajınızın içeriği işlenir ve ABD'ye de aktarılır. Hukuki dayanak GDPR md. 6 f. 1 (f)'dir. Bu nedenle lütfen e-posta ile sağlık verisi göndermeyin; bunun yerine telefonu ya da yüz yüze görüşmeyi tercih edin.",
        "Web sitemizde bize WhatsApp'tan yazabileceğiniz bir bağlantı bulunur. Sağlayıcı WhatsApp Ireland Limited, 4 Grand Canal Square, Grand Canal Harbour, Dublin 2, İrlanda'dır. Bağlantı yalnızca bir yönlendirmedir: Ancak ona tıkladığınızda WhatsApp ile bağlantı kurulur ve cep telefonu numaranız ile mesajınızın içeriği WhatsApp'a aktarılır. Hukuki dayanak GDPR md. 6 f. 1 (b)'dir. WhatsApp verileri AB dışında da işler; Meta, AB-ABD Veri Gizliliği Çerçevesi kapsamında sertifikalıdır. Lütfen WhatsApp üzerinden sağlık verisi göndermeyin ve acil durumlarda telefonu kullanın.",
      ],
    },
    applications: {
      title: "6. İş başvuruları",
      p: [
        "İş ilanlarımıza başvurular bize e-posta ile gönderilir. Başvuru belgelerinizi yalnızca başvuru sürecini yürütmek için işleriz (GDPR md. 6 f. 1 (b), BDSG § 26). Süreç tamamlandıktan sonra belgeler, daha uzun saklamaya rıza vermediyseniz ya da bir iş ilişkisi kurulmadıysa, en geç altı ay içinde silinir.",
      ],
    },
    maps: {
      title: "7. Google Haritalar (iki tıklama çözümü)",
      p: [
        "İletişim sayfasında Google Haritalar hizmetinin bir haritasını sunuyoruz. Sağlayıcı: Google Ireland Limited, Gordon House, Barrow Street, Dublin 4, İrlanda. Harita **yalnızca “Haritayı yükle” düğmesine açıkça tıkladığınızda** yüklenir; öncesinde Google'a hiçbir veri gönderilmez. Tıklayarak Google'ın IP adresinizi ve kullanım verilerinizi işlemesine ve gerekirse ABD'deki Google LLC sunucularına aktarmasına rıza verirsiniz (GDPR md. 6 f. 1 (a)); bu sırada Google cihazınıza çerez yerleştirebilir. Google, AB-ABD Veri Gizliliği Çerçevesi kapsamında sertifikalıdır ve ek olarak standart sözleşme maddelerini kullanır. Rızanız yalnızca o anki sayfa görüntülemesi için geçerlidir. Daha fazla bilgi: [policies.google.com/privacy](https://policies.google.com/privacy).",
      ],
    },
    rights: {
      title: "8. Haklarınız",
      lead: "Kişisel verilerinizle ilgili olarak bize karşı şu haklara sahipsiniz:",
      items: [
        "Bilgi edinme (GDPR md. 15)",
        "Düzeltme (GDPR md. 16)",
        "Silme (GDPR md. 17)",
        "İşlemenin kısıtlanması (GDPR md. 18)",
        "Veri taşınabilirliği (GDPR md. 20)",
        "GDPR md. 6 f. 1 (f)'ye dayanan işlemeye itiraz (GDPR md. 21)",
        "Verilen rızanın ileriye dönük geri alınması (GDPR md. 7 f. 3)",
      ],
      how: "Haklarınızı kullanmak için {email} adresine ya da yukarıdaki posta adresine gönderilecek resmiyet gerektirmeyen bir bildirim yeterlidir.",
    },
    authority: {
      title: "9. Denetim makamına şikâyet hakkı",
      lead: "Bir veri koruma denetim makamına şikâyette bulunma hakkınız vardır (GDPR md. 77). Bizim için yetkili makam:",
      name: "Hessen Veri Koruma ve Bilgi Edinme Özgürlüğü Komiseri",
      address: "Gustav-Stresemann-Ring 1, 65189 Wiesbaden, Almanya",
      url: "https://datenschutz.hessen.de",
      urlLabel: "datenschutz.hessen.de",
    },
    security: {
      title: "10. Veri güvenliği",
      p: [
        "Bu web sitesi yalnızca şifreli HTTPS bağlantısı (TLS) üzerinden sunulur. Verilerinizi kayıp, manipülasyon ve yetkisiz erişime karşı korumak için teknik ve organizasyonel önlemler alıyor ve bunları teknolojik gelişmelere göre sürekli güncelliyoruz.",
      ],
    },
    changes: {
      title: "11. Bu gizlilik politikasındaki değişiklikler",
      p: [
        "Hukuki durum ya da web sitemiz değiştiğinde bu gizlilik politikasını güncelleriz. Burada yayımlanan sürüm geçerlidir.",
      ],
    },
  },
};

export default tr;
